import React from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../sections/Footer/Footer';
import Gallery from '../sections/Gallery/Gallery';
import ServiceBanner from '../sections/ServiceBanner/ServiceBanner';
import Symptoms from '../sections/Symptoms/Symptoms';
import Appointment from '../sections/Appointment/Appointment';
import ServicesData from '../sections/Services/ServiceData';

const Services = ({ service = "Dental Services" }) => {
    const location = useLocation();
    const path = location.pathname.substring(1);
    
    // Services that need the Symptoms section
    const servicesWithSymptoms = [
        'root-canals',
        'dental-implants',
        'teeth-whitening',
        'orthodontics',
        'invisalign'
    ];
    
    // Check if current service needs Symptoms section
    const showSymptoms = servicesWithSymptoms.includes(path);
    
    return (
        <>
            <Navbar />
            <ServiceBanner />
            {showSymptoms && <Symptoms />}
            <Appointment />
            <Footer />
        </>
    );
};

export default Services;
